import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { getenv } from '~/settings'
import Box from '~/core/Box'
import { NavigationContext } from '~/core/NavigationConfig'
import { UnauthenticatedLayout } from '../components'
import styles from '../styles.css'

import LoginForm from './LoginForm'
import MfaSection from './MfaSection'
import { useExtractParams } from './logic'
import { EMAIL_PARAM } from './constants'

const PLACEMENT = 'login-form'
const MARKETING_IMG_URL =
    'https://www.fictiv.com/wp-content/uploads/platform/login-page.png'

export default function LoginPage() {
    const { search: queryString } = useLocation()

    const { setNavigationConfig } = useContext(NavigationContext)

    useEffect(() => {
        setNavigationConfig({ noNavWrapper: true })
    }, [setNavigationConfig])

    const queryParams = useExtractParams(queryString)
    const emailAddress = queryParams[EMAIL_PARAM]

    const [mfaEnabled, setMfaEnabled] = useState<boolean>(false)
    const [session, setSession] = useState<string>('')
    const [email, setEmail] = useState<string>(emailAddress || '')

    const disableSignup = getenv('DISABLE_SIGNUP')

    // If DISABLE_SIGNUP is true, always hide the link, otherwise fall back to mfaEnable flag
    const showSignupLink = disableSignup ? false : !mfaEnabled

    return (
        <UnauthenticatedLayout
            placement={PLACEMENT}
            queryString={queryString}
            showSignupLink={showSignupLink}
            showBackground
        >
            {mfaEnabled && session ? (
                <MfaSection session={session} email={email} />
            ) : (
                <Box
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'min-content',
                    }}
                >
                    <Box
                        className={styles.section}
                        style={{
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                        }}
                    >
                        <Box className={styles.header}>
                            Log in to your account
                        </Box>
                        <LoginForm
                            placement={PLACEMENT}
                            setMfaEnabled={setMfaEnabled}
                            setSession={setSession}
                            setEmail={setEmail}
                            initialEmailValue={email}
                        />
                    </Box>
                    <Box margin="-32px 0 32px">
                        <img src={MARKETING_IMG_URL} width="100%" />
                    </Box>
                </Box>
            )}
        </UnauthenticatedLayout>
    )
}
